import { api } from '@/lib/api'

export interface ClientOrg {
  id: number
  name: string
  domain?: string
  sectors?: string[]
  portal_access_enabled?: boolean
  public_id?: string // stable, hard-to-guess UUID visible in URLs/externally
}

export async function getClients(params?: Record<string, any>) {
  const { data } = await api.get<ClientOrg[] | { results: ClientOrg[]; count: number }>(`/api/projects/clients/`, { params })
  if (Array.isArray(data)) return { items: data, count: data.length }
  return { items: data.results, count: data.count }
}

export async function createClient(payload: { name: string; domain?: string; sectors?: string[]; primary_contact?: number; public_id?: string }) {
  // Generate a high-entropy UUID on the client if the backend doesn't create one.
  let public_id = payload.public_id
  try {
    if (!public_id && typeof crypto !== 'undefined' && 'randomUUID' in crypto) {
      public_id = crypto.randomUUID()
    }
  } catch {}

  const body = { ...payload, public_id }
  const { data } = await api.post<ClientOrg>(`/api/projects/clients/`, body)
  return data
}

export async function updateClient(
  id: number,
  payload: { name?: string; domain?: string; sectors?: string[]; portal_access_enabled?: boolean; primary_contact?: number }
) {
  const { data } = await api.patch<ClientOrg>(`/api/projects/clients/${id}/`, payload)
  return data
}

export async function deleteClient(id: number) {
  await api.delete(`/api/projects/clients/${id}/`)
}
